<div class="footer">

  <div id="footerLayout" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="flex-start">

    <div fxFlex="70" [fxFlex.lt-md]="0">

      <img src="assets/img/logo_pilomat_grey.png" style="max-width: 100px; margin-bottom: 13px;"><br />
      PILOMAT s.r.l. Via Zanica 17/p - 24050 Grassobbio (BG) Italy<br />
      Tel. +39 035 297220 - Fax +39 035 297094 - E-mail: pilomat@pilomat.com<br />
      P.iva / C.F. : 00383760162

    </div>

    <div fxFlex="30" [fxFlex.lt-md]="0">

      <a routerLink="/privacy-terms" class="iubenda-nostyle iubenda-embed " i18n="@@footer_privacy_terms_link">
        Informativa d'uso e Condizioni del servizio
      </a>
      <p class="text-small margin-top-10">
        <ng-container i18n="@@footer_version">Versione</ng-container> {{ version }}
      </p>
      <p class="text-small margin-top-10">
        {{ username }}
      </p>
      <p class="text-small margin-top-10">
        {{ userType }}
      </p>

    </div>

  </div>

</div>
